import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import PostHeader from '../post/postHeader';
import PostEngagement from '../post/postEngagement';
import FeedCardContent from '../feedCardContent';
import useReactRouter from 'use-react-router';
import { useStoreActions, useStoreState } from 'easy-peasy';
import TopPost from '../common/topPost';
import PostLanguage from '../common/postLanguage';
import ApprovePost from '../common/approvePost';
import { checkUserType } from '../../utils/userUtil';
import { userType } from '../../utils/constants';
import authService from '../../services/authService';
import ScheduleMessage from '../post/scheduleMessage';
import WomenWillVideo from '../post/womenWillVideo';

const Post = ({
  post,
  isPostDetail,
  focusComment,
  lectureEntityId,
  isLecture,
  lectureData,
  lectureObj,
  chapterTitle,
}) => {
  const { history } = useReactRouter();
  const [showCommentBox, setShowCommentBox] = useState(false);
  const user = authService.getCurrentUser();
  const postId = post.id;
  const setScrollPostId = useStoreActions(
    (actions) => actions.feed.setScrollPostId
  );
  const isTopPost = useStoreState(
    (state) => state.posts.postsObj[postId].isTopPost
  );
  function handleClick() {
    if (!isPostDetail) {
      setScrollPostId(post.id);
      history.push(post.slug, { postId });
    }
  }
  async function handleClickAskQuestion() {
    setShowCommentBox(true);
  }
  return (
    <React.Fragment>
      <Box mb={2} className="wordBreak boxShadowBottom positionRelative">
        {isLecture ? (
          <WomenWillVideo
            handleClickAskQuestion={handleClickAskQuestion}
            post={lectureData}
            user={user}
          />
        ) : (
          <Box>
            <Box display="block">
              {isTopPost && <TopPost />}
              {(checkUserType(userType.isAdmin) ||
                checkUserType(userType.isCommunityMod)) && (
                <PostLanguage post={post} />
              )}
            </Box>

            <PostHeader
              showOptions={true}
              isPostDetail={isPostDetail}
              history={history}
              post={post}
              postId={postId}
              user={user}
            />

            <Box className="clearfix" onClick={handleClick}>
              <FeedCardContent isPostDetail={isPostDetail} post={post} />

              {post.isSchedulePost && <ScheduleMessage />}
            </Box>
          </Box>
        )}

        {((!post.isSpamPost && !post.isSchedulePost) || isLecture) && (
          <PostEngagement
            showCommentBox={showCommentBox}
            isPostDetail={isPostDetail}
            focusComment={focusComment}
            post={post}
            lectureEntityId={lectureEntityId}
            isLecture={isLecture}
            lectureObj={lectureObj}
            chapterTitle={chapterTitle}
          />
        )}

        {user && (
          <ApprovePost
            post={post}
            isUserAdmin={checkUserType(userType.isAdmin)}
            isCommunityMod={checkUserType(userType.isCommunityMod)}
          />
        )}
      </Box>
    </React.Fragment>
  );
};

export default Post;
